import { render, staticRenderFns } from "./NonComplianceReport.vue?vue&type=template&id=2adefdc3"
import script from "./NonComplianceReport.vue?vue&type=script&lang=ts"
export * from "./NonComplianceReport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports